import { Link } from "react-router-dom";
import type { ChannelCoverageBadge } from "@/lib/channel-coverage";
import { listingLiveLinks } from "@/lib/listing-live-display";
import { ViewLiveLink } from "@/components/feature/ViewLiveLink";

const kindClass: Record<ChannelCoverageBadge["matrixKind"], string> = {
  listed: "text-emerald-800",
  paused: "text-amber-800",
  needs_sync: "text-amber-800",
  not_listed: "text-slate-500",
  error: "text-red-700",
};

const kindIcon: Record<ChannelCoverageBadge["matrixKind"], string> = {
  listed: "ri-checkbox-circle-fill",
  paused: "ri-pause-circle-fill",
  needs_sync: "ri-error-warning-fill",
  not_listed: "ri-close-circle-line",
  error: "ri-close-circle-fill",
};

export function ChannelMatrixCell(props: {
  badge: ChannelCoverageBadge;
  productId: string;
  storefrontOrigin?: string;
  customUrl?: string;
}) {
  const b = props.badge;
  const live = listingLiveLinks({
    provider: b.provider,
    externalId: b.liveExternalId,
    storefrontOrigin: props.storefrontOrigin,
    customUrl: props.customUrl,
  }).liveUrl;
  const channelsHref = `/products/${props.productId}?tab=channels`;

  return (
    <div className="min-w-[8.5rem] max-w-[11rem]" onClick={(e) => e.stopPropagation()}>
      <p className={`text-xs font-semibold leading-tight inline-flex items-start gap-1 ${kindClass[b.matrixKind]}`}>
        <i className={`${kindIcon[b.matrixKind]} mt-0.5 shrink-0`} aria-hidden />
        <span className="min-w-0">
          <span className="block">{b.matrixLabel}</span>
          {b.pendingManualLabels.length > 0 ? (
            <span className="block font-medium text-[11px] leading-tight mt-0.5">
              {b.pendingManualLabels.join(" · ")}
            </span>
          ) : null}
          {b.automaticLine ? (
            <span className="block font-medium text-[11px] leading-tight mt-0.5">{b.automaticLine}</span>
          ) : null}
        </span>
      </p>
      <div className="mt-0.5">
        {b.matrixKind === "listed" || b.matrixKind === "paused" || b.matrixKind === "needs_sync" ? (
          <ViewLiveLink href={live} />
        ) : null}
        {b.matrixKind === "not_listed" ? (
          <Link to={channelsHref} className="text-[11px] font-medium text-emerald-700 hover:text-emerald-800 whitespace-nowrap">
            Create listing
          </Link>
        ) : null}
        {b.matrixKind === "error" ? (
          <Link to={channelsHref} className="text-[11px] font-medium text-red-700 hover:text-red-800 whitespace-nowrap">
            Review issue
          </Link>
        ) : null}
        {b.matrixKind === "needs_sync" ? (
          <Link to={channelsHref} className="block text-[11px] font-medium text-amber-800 hover:text-amber-900 whitespace-nowrap">
            Review sync
          </Link>
        ) : null}
      </div>
    </div>
  );
}
